import { useState } from "react";
import { ArrowRight, CheckCircle2, Loader2 } from "lucide-react";
import { motion } from "framer-motion";
import api, { apiErr } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | ok | err
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading"); setMsg("");
    try {
      const { data } = await api.post("/subscribe", { email });
      setStatus("ok");
      setMsg(data.already ? "आप पहले से सदस्य हैं — धन्यवाद!" : "धन्यवाद! अगला अंक कल सुबह 7 बजे मिलेगा।");
      setEmail("");
      setTimeout(() => setStatus("idle"), 5000);
    } catch (e2) {
      setStatus("err");
      setMsg(apiErr(e2.response?.data?.detail) || "कुछ गड़बड़ हुई — फिर कोशिश करें");
    }
  };

  return (
    <section
      id="subscribe"
      data-testid="newsletter-section"
      className="relative bg-[#F4F4F0] border-t border-[#0F0F0F]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-20 md:py-28 grid grid-cols-12 gap-10 items-center">
        <div className="col-span-12 lg:col-span-6">
          <div className="eyebrow text-[#D92525] mb-4">रोज़ सुबह, आपके इनबॉक्स में</div>
          <h2 className="font-serif-dev font-black text-[40px] md:text-[60px] leading-[1.02]">
            चाय के साथ <span className="italic">देनवा</span>।
          </h2>
          <p className="mt-6 font-sans-dev text-[16px] md:text-[18px] text-[#4A4A4A] leading-relaxed max-w-[520px]">
            पिछले 24 घंटे की सबसे ज़रूरी 7 ख़बरें, संपादकीय टीम की टिप्पणी और आज का पंचांग—एक ईमेल में।
          </p>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <motion.form
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            onSubmit={submit}
            data-testid="newsletter-form"
            className="border border-[#0F0F0F] bg-white p-5 md:p-6 flex items-center gap-3 flex-col md:flex-row"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="आपका ईमेल पता"
              data-testid="newsletter-input"
              className="flex-1 w-full bg-transparent outline-none font-sans-dev text-[16px] md:text-[18px] py-3 md:py-4 px-1 placeholder:text-[#0F0F0F]/40"
              required
              disabled={status === "loading"}
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              disabled={status === "loading"}
              className="w-full md:w-auto pill-btn text-[12px] justify-center disabled:opacity-60"
            >
              {status === "loading" ? <Loader2 size={16} className="animate-spin" /> : <>सदस्य बनें <ArrowRight size={16} /></>}
            </button>
          </motion.form>
          {status === "ok" && (
            <motion.div
              data-testid="newsletter-success"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              className="mt-4 flex items-center gap-2 text-[13px] text-[#0A0A0A]"
            >
              <CheckCircle2 size={16} className="text-[#D92525]" />
              {msg}
            </motion.div>
          )}
          {status === "err" && (
            <div data-testid="newsletter-error" className="mt-4 text-[13px] text-[#D92525]">
              {msg}
            </div>
          )}
          <p className="mt-4 font-sans-dev text-[11px] tracking-[0.18em] uppercase text-[#4A4A4A]">
            कभी स्पैम नहीं · कभी भी अनसब्सक्राइब
          </p>
        </div>
      </div>
    </section>
  );
}
